import React from "react";
//MUI
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
} from "@mui/material";
import { Cancel } from "@mui/icons-material";
import { CLOSE_GIFT_DIALOG } from "../../../store/Gift/gift.type";
import { connect, useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getGiftCategory } from "../../../store/GiftCategory/GiftCategory.action";
import { useState } from "react";
import { updateGift } from "../../../store/Gift/gift.action";

import { baseURL } from "../../../util/config";
import { setToast } from "../../../util/toast";



function EditGift(props) {
  const dispatch = useDispatch();
  const [mongoId, setMongoId] = useState("");
  const [coin, setCoin] = useState("");
  const [adlar, setAdlar] = useState({ name: "", name_ar: "", name_en: "" });
  const [category, setCategory] = useState("");
  const [platFormType, setPlatFormType] = useState("");
  const [imageData, setImageData] = useState(null);
  const [imagePath, setImagePath] = useState(null);
  const [svga, setSvga] = useState(null);
  const [errors, setError] = useState("");
  const { dialogOpen: open, dialogData } = useSelector((state) => state.gift);
  const { giftCategory } = useSelector((state) => state.giftCategory);
  
  
  useEffect(() => {
    dispatch(getGiftCategory());
  }, [dispatch]);

  useEffect(() => {
    window.onbeforeunload = closePopup();
  }, []);

  useEffect(() => {
    setMongoId(dialogData?._id);
    setCoin(dialogData?.coin);
    setAdlar({ name: dialogData?.name || "", name_ar: dialogData?.i18n?.ar || "", name_en: dialogData?.i18n?.en || "" });
    setCategory(dialogData?.category);
    setPlatFormType(dialogData?.platFormType);
    setImagePath(baseURL + dialogData?.image);
  }, [dialogData]);

  const closePopup = () => {
    dispatch({ type: CLOSE_GIFT_DIALOG });
  };
  const GiftClick = sessionStorage.getItem("giftClick");

  const categoryDetail = JSON.parse(sessionStorage.getItem("category"));

  const HandleInputImage = (e) => {
    if (e.target.files[0]) {
      setImageData(e.target.files[0]);
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        setImagePath(reader.result);
      });
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (
      (!imageData && !imagePath) ||
      !coin ||
      (GiftClick !== null && (!category || category === "Select Category"))
    ) {
      let errors = {};
      if (!coin) errors.coin = "Coin is Required!";

      if (!imageData && !imagePath) errors.image = "Please select an Image!";

      if (GiftClick !== null && (category === "Select Category" || !category)) {
        errors.category = "Please select a Category!";
      }
      setError({ ...errors });
    } else {
      const coinValid = isNumeric(coin);
      if (!coinValid) {
        return setError({ ...errors, coin: "Invalid Coin!!" });
      }
      const formData = new FormData();

      if (imageData) formData.append("image", imageData);
      if (svga) formData.append("svga", svga);
      formData.append("coin", coin);
      Object.entries(adlar).forEach(([k, v]) => formData.append(k, v || ""));
      GiftClick !== null && formData.append("category", category);
      // Hediyeler platforma gore ayrilmaz; mevcut deger korunur.
      formData.append("platFormType", platFormType || 0);
       
      props.updateGift(mongoId, formData);
      closePopup();
    }
  };

  const isNumeric = (value) => {
    const val = value === "" ? 0 : value;
    const validNumber = /^\d+$/.test(val);
    return validNumber;
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSubmit();
    }
  };
  return (
    <Dialog
      open={open}
      aria-labelledby="responsive-dialog-title"
      onClose={closePopup}
      fullWidth
      maxWidth="xs"
    >
      <DialogTitle
        id="responsive-dialog-title"
        className="dialogue_background_color"
      >
        <span className="modal-title font-weight-bold h4"> Hediye </span>
      </DialogTitle>

      <IconButton
        style={{
          position: "absolute",
          right: 0,
          color: "#664dc9",
        }}
      >
        <Tooltip title="Kapat" placement="right">
          <Cancel className="modal-title cancelButton" onClick={closePopup} />
        </Tooltip>
      </IconButton>
      <DialogContent className="dialogue_background_color">
        <div className="modal-body pt-1 px-1 pb-3">
          <div className="d-flex flex-column">
            <form>

              {/* hediye adi: 3 dil (uygulamada kullanicinin diline gore gorunur) */}
                <div className="row">
                  {[["name", "Ad · Türkçe", "Gül"], ["name_ar", "Ad · Arapça", "وردة"], ["name_en", "Ad · İngilizce", "Rose"]].map(([k, ad, ph]) => (
                    <div className="col-md-4" key={k}>
                      <div className="form-group">
                        <label className="float-left dialog__input__title">{ad}</label>
                        <input
                          className="form-control"
                          maxLength={40}
                          dir={k === "name_ar" ? "rtl" : "ltr"}
                          placeholder={ph}
                          value={adlar[k] || ""}
                          onChange={(e) => setAdlar({ ...adlar, [k]: e.target.value })}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              <div className="row">
                <div className="col-md-12 my-2">
                  <label className="mb-2 dialog__input__title">Coin</label>
                  <input
                    type="number"
                    className="form-control pe-1"
                    required=""
                    placeholder="20"
                    value={coin}
                    onChange={(e) => {
                      setCoin(e.target.value);
                      if (!e.target.value) {
                        return setError({
                          ...errors,
                          coin: "Coin is Required!",
                        });
                      } else {
                        return setError({
                          ...errors,
                          coin: "",
                        });
                      }
                    }}
                    onKeyPress={handleKeyPress}
                  />
                  {errors.coin && (
                    <div className="ml-2 mt-1">
                      {errors.coin && (
                        <div className="pl-1 text__left">
                          <span style={{ color: "#009688" }}>
                            {errors.coin}
                          </span>
                        </div>
                      )}
                    </div>
                  )}
                </div>
                <div className="col-md-12 my-2">
                  <label className="dialog__input__title mb-2">Kategori</label>
                  {GiftClick === null ? (
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Kategori adı"
                      value={categoryDetail?.name}
                    />
                  ) : (
                    <>
                      <select
                        class="form-select form-control"
                        aria-label="Seçim"
                        value={category}
                        onChange={(e) => {
                          setCategory(e.target.value);
                          if (e.target.value === "Select Category") {
                            return setError({
                              ...errors,
                              category: "Please select a Category!",
                            });
                          } else {
                            return setError({
                              ...errors,
                              category: "",
                            });
                          }
                        }}
                        onKeyPress={handleKeyPress}
                      >
                        <option value="Select Category" selected>
                          Select Category
                        </option>
                        {giftCategory.map((category) => {
                          return (
                            <>
                              <option value={category._id}>
                                {category.name}
                              </option>
                            </>
                          );
                        })}
                      </select>
                      {errors.category && (
                        <div className="ml-2 mt-1">
                          {errors.category && (
                            <div className="pl-1 text__left">
                              <span className="text-danger">
                                {errors.category}
                              </span>
                            </div>
                          )}
                        </div>
                      )}
                    </>
                  )}
                </div>
                <div className="col-md-12 my-2">
                  <label className="mb-2 dialog__input__title">Tam ekran animasyon (SVGA, isteğe bağlı)</label>
                  <input
                    type="file"
                    className="form-control"
                    onChange={(e) => {
                      // accept=".svga" macOS'ta dosyayi secilemez yapiyordu; kontrol burada
                      const f = e.target.files?.[0] || null;
                      if (f && !/\.svga$/i.test(f.name)) {
                        setToast("error", "Yalnızca .svga dosyası yükleyebilirsin");
                        e.target.value = "";
                        return setSvga(null);
                      }
                      setSvga(f);
                    }}
                  />
                  <small style={{ color: "#64748B" }}>Hediye gönderilince ekranda oynar. Ekrana sığacak şekilde gösterilir.</small>
                </div>
                <div className="col-md-12 my-2">
                  <label className="mb-2 dialog__input__title">
                    Select Image or GIF
                  </label>
                  <input
                    type="file"
                    className="form-control"
                    accept="image/*"
                    required=""
                    onChange={HandleInputImage}
                    onKeyPress={handleKeyPress}
                  />
                  {errors.image && (
                    <div className="ml-2 mt-1">
                      {errors.image && (
                        <div className="pl-1 text__left">
                          <span style={{ color: "#009688" }}>
                            {errors.image}
                          </span>
                        </div>
                      )}
                    </div>
                  )}
                  {imagePath && (
                    <>
                      <img
                        height="70px"
                        width="70px"
                        alt="app"
                        src={imagePath}
                        draggable="false"
                        style={{
                          marginTop: 10,
                          float: "left",
                          borderRadius: "12px",
                        }}
                      />
                    </>
                  )}
                </div>
              </div>
              <DialogActions>
                <button
                  type="button"
                  className="btn  btn-success  mx-2"
                  onClick={handleSubmit}
                >
                  Kaydet
                </button>
                <button
                  type="button"
                  className="btn btn-outline-danger "
                  onClick={closePopup}
                >
                  Kapat
                </button>
              </DialogActions>
            </form>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default connect(null, { getGiftCategory, updateGift })(EditGift);
